<ng-container *ngIf="certs || certs.length > 0; else noCerts">
    <ng-container *ngFor="let cert of certs; let isLast = last">
        <span *ngIf="cert.changeType === changeType.Added && !cert.newValue?.isNA">
            <span class="job-qualifications-compare-change-added">{{cert.newValue.name}}{{cert.newValue.isPreferred ? '*' : ''}}</span>
            <span *ngIf="!isLast">, </span>
        </span>
        <span *ngIf="cert.changeType === changeType.Removed && cert.originalValue !== null">
            <span class="job-qualifications-compare-change-removed">{{cert.originalValue?.name}}{{cert.originalValue?.isPreferred ? '*' : ''}}</span>
            <span *ngIf="!isLast">, </span>
        </span>
        <span *ngIf="cert.changeType === changeType.Changed && cert.originalValue !== null">
            <span class="job-qualifications-compare-change-removed">{{cert.originalValue?.name}}{{cert.originalValue?.isPreferred ? '*' : ''}}</span>&nbsp;<span class="job-qualifications-compare-change-added">{{cert.newValue?.name}}{{cert.newValue?.isPreferred ? '*' : ''}}</span>
            <span *ngIf="!isLast">, </span>
        </span>
        <span *ngIf="cert.changeType === changeType.Unchanged && cert.originalValue && !cert.originalValue.isNA">
            <span>{{cert.originalValue.name}}{{cert.originalValue.isPreferred ? '*' : ''}}</span> 
            <span *ngIf="!isLast">, </span>
        </span>
    </ng-container>
</ng-container>
<ng-template #noCerts>-</ng-template>